import { LatestTransaction, NoTransactionsMessage } from '@components'
import NoTransactionsImage from '@images/icons/transactions-icon.png'
import { useGetTransactionsQuery } from 'mmfintech-backend-api'
import { isValidArray } from 'mmfintech-commons'
import { ErrorDisplay, Spinner } from 'mmfintech-portal-commons'

export const Recent = () => {
  const {
    data: transactionsResponse,
    error: transactionsError,
    isFetching: transactionsFetching
  } = useGetTransactionsQuery({
    page: 0,
    size: 3,
    sort: 'reqTime-desc,id-desc'
  })

  return (
    <>
      {transactionsFetching ? (
        <Spinner />
      ) : transactionsError ? (
        <ErrorDisplay error={transactionsError} />
      ) : isValidArray(transactionsResponse?.content) ? (
        <div className='transaction-section-content'>
          {transactionsResponse.content.map(data => {
            const {
              id,
              reqTime,
              amount,
              currency,
              direction,
              status,
              trnTypeLocalizationKey,
              transactionCategory,
              cardPaymentDetails,
              documentRequest
            } = data

            return (
              <LatestTransaction
                data-test={`latest-transaction-${id}`}
                key={id}
                amount={amount}
                currency={currency}
                direction={direction}
                reqTime={reqTime}
                status={status}
                trnTypeLocalizationKey={trnTypeLocalizationKey}
                transactionCategory={transactionCategory}
                cardPaymentDetails={cardPaymentDetails}
                documentRequest={documentRequest}
              />
            )
          })}
        </div>
      ) : (
        <NoTransactionsMessage iconLink={NoTransactionsImage} />
      )}
    </>
  )
}
